import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiClient } from '../common/api-client.service';

interface Txn {
  id: number;
  date: string;
  dDate?: Date;
  amount: number;
  fund_id: number;
  account_id: number;
  tag_list: string;
}

@Component({
  templateUrl: './edit.component.html'
})
export class TxnsEditComponent implements OnInit {
  funds: Array<any> = [];
  accounts: Array<any> = [];
  txn: Txn = {id: null, date: null, amount: null, fund_id: null, account_id: null, tag_list: null};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private apiClient: ApiClient,
  ) {}

  ngOnInit() {
    this.apiClient.get<any>('/api/v1/ledger/details').toPromise().then(ledger => {
      this.funds = ledger.funds;
      this.accounts = ledger.accounts;
    });

    const txnId = this.route.snapshot.params['id'];
    this.apiClient.get<Txn>(`/api/v1/transactions/${txnId}`).toPromise().then(data => {
      const d = data.date.split('-').map(x => parseInt(x, 10));
      data.dDate = new Date(d[0], d[1]-1, d[2]);
      this.txn = data;
    });
  }

  save(): void {
    const data = {id: this.txn.id, fund_id: this.txn.fund_id, account_id: this.txn.account_id, amount: this.txn.amount,
    tag_list: this.txn.tag_list, date: null};
    data.date = this.txn.dDate ? this.datePipe.transform(this.txn.dDate, 'yyyy-MM-dd') : null;

    this.apiClient.patch<Txn>(`/api/v1/transactions/${this.txn.id}`, data).toPromise().then(t => {
      // TODO success
      this.router.navigateByUrl('/')
    }, resp => {
      // TODO error
      alert(resp.error.errors);
    });
  }
}



// WEBPACK FOOTER //
// /srv/src/app/txns/edit.component.ts